import React from 'react'

export default()=>(
    <style js="true">{
        `

        .heading-first-section7{
            display: flex;
            justify-content: space-around;
            color: #00658d;
        }
        .heading-first-section7 .h1 {
            font-weight: 600;
        }
        .left-side-section7{
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .paragraph1-section7{
            padding-top: 4%;
            font-size: 25px;
            color: #f38524;
        }
        .paragraph2-section7{
            font-size: 21px;
            width: 338px;
            padding-left: 60px;
            color: #5896af;
        }

        .middle-section7{
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .middle-paragraph1-section7{
            padding-top: 6%;
            font-size: 25px;
            color: #f38524;
            font-weight: 500;
        }
        .middle-paragraph2-section7{
            font-size: 21px;
            width: 476px;
            padding-left: 60px;
            color: #5896af;
        }



        .right-side-section7{
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .right-paragraph1-section7{
            padding-top: 8%;
            font-size: 25px;
            color: #f38524;
            font-weight: 500;
            width: 452px;
            text-align: center;
        }
        .right-paragraph2-section7{
            font-size: 21px;
            width: 392px;
            // padding-left: 4px;
            color: #5896af;
        }
        .col-data{
            padding-top: 5%;
        }
        .top-border {
            border-top: 1px solid;
            border-color: #b7b7b7;
            padding-bottom: 37px;
        }
        
      

        
        
        /* --------------------------------- */

        `
    }

    </style>
);